import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {CfgAutoCheckOutModel} from '../../../models/configuration/cfg-task-auto-checkout.model';
import {CfgARPaymentProcessorModel} from '../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import {PaymentProcessorDeviceListModel} from "../models/payment-processor-device-list.model";

@Injectable({
  providedIn: 'root'
})
export class CheckoutProcessorConfigurationService {

  constructor(private http: HttpClient) { }


  saveCheckOutProcessors(checkOutProcessors: any): Observable<CfgAutoCheckOutModel[]> {
    return this.http.post<CfgAutoCheckOutModel[]>(`${environment.TDOurl}checkout-processor-configuration/save-processor/`, checkOutProcessors);
  }

  getCheckOutProcessor(locid: string): Observable<CfgAutoCheckOutModel[]> {
    let url: string;
    const method: string = 'checkout-processor-configuration/checkout-processor-by-location/' + locid;
    url = environment.TDOurl + method;
    //return this.http.get<CfgAutoCheckOutModel[]>(url);
    return this.http.get<CfgAutoCheckOutModel[]>(`${environment.TDOurl}checkout-processor-configuration/checkout-processor-by-location/` + locid);
  }


  /*saveProcessor(processor: CfgARPaymentProcessorModel): Observable<CfgARPaymentProcessorModel> {
    return this.http.post<CfgARPaymentProcessorModel>('/api/payment-processor-configuration/save-processor/', processor);
  }*/
}
